export default __webpack_public_path__ + "static/media/user-pics-7.01020d95.png";